// extracted by mini-css-extract-plugin
export default {"news":"NewsPage_news__9GoI-","news__title":"NewsPage_news__title__GjG4L","news__subtitle":"NewsPage_news__subtitle__oOhCw","news__descr":"NewsPage_news__descr__39cKY"};